export default {
  name: "Preparer",
  prefix: "G",
  pageInfo: {
    text: `Complete this section if the preparer of this application is a person other than the one identified in either Section C (employer point of contact) or section D (attorney or agent) of this application.`,
    coloring: `grey`,
  },
  sections: [
    {
      fields: [
        {
          code: "G.1",
          machine_name: "eg1_prep_last",
          widget: "text",
          label: "Last (family) name",
          maxLength: 35,
          tooltip: `Enter the last (family) name of the person preparing this application by or on behalf of the employer.`,
          validate: [
            {
              valueChecker: "eg1_prep_last",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: [
                  "eg1_prep_last",
                  "eg2_prep_first",
                  "eg4_prep_fein",
                  "eg5_prep_firm_name",
                  "eg6_prep_email",
                ],
                check: "ifValueExists",
              },
            },
            {
              minLength: 2,
              message: "Last Name must contain at least 2 characters",
            },
          ],
        },
        {
          code: "G.2",
          machine_name: "eg2_prep_first",
          widget: "text",
          label: "First (given) name",
          maxLength: 35,
          tooltip: `Enter the first (given) name of the person preparing this application by or on behalf of the employer.`,
          validate: [
            {
              valueChecker: "eg2_prep_first",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: [
                  "eg1_prep_last",
                  "eg2_prep_first",
                  "eg4_prep_fein",
                  "eg5_prep_firm_name",
                  "eg6_prep_email",
                ],
                check: "ifValueExists",
              },
            },
            {
              minLength: 2,
              message: "First Name must contain at least 2 characters",
            },
          ],
        },
        {
          code: "G.3",
          machine_name: "eg3_prep_middle",
          widget: "text",
          label: "Middle Initial",
          maxLength: 3,
          tooltip: `If applicable, enter the middle initial of the person preparing this application by or on behalf of the employer. If the preparer does not have a middle name, enter “N/A.”`,
        },
        {
          code: "G.4",
          machine_name: "eg4_prep_fein",
          widget: "text",
          label: "Law Firm/Business FEIN",
          maxLength: 10,
          tooltip: `Enter the FEIN, assigned by the IRS, for the firm or business submitting this application by or on behalf of the employer.`,
          parse: "fein",
          validate: [
            "fein",
            {
              valueChecker: "eg4_prep_fein",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: [
                  "eg1_prep_last",
                  "eg2_prep_first",
                  "eg4_prep_fein",
                  "eg5_prep_firm_name",
                  "eg6_prep_email",
                ],
                check: "ifValueExists",
              },
            },
            { minLength: 10, message: "This is not a valid FEIN" },
          ],
        },
        {
          code: "G.5",
          machine_name: "eg5_prep_firm_name",
          widget: "text",
          label: "Law Firm/Business Name",
          maxLength: 120,
          tooltip: `Enter the name of the firm or business that prepared this application by or on behalf of the employer.`,
          validate: [
            {
              valueChecker: "eg5_prep_firm_name",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: [
                  "eg1_prep_last",
                  "eg2_prep_first",
                  "eg4_prep_fein",
                  "eg5_prep_firm_name",
                  "eg6_prep_email",
                ],
                check: "ifValueExists",
              },
            },
            {
              minLength: 5,
              message: "Legal Business Name must contain at least 5 characters",
            },
          ],
        },
        {
          code: "G.6",
          machine_name: "eg6_prep_email",
          widget: "text",
          label: "Law Firm/Business Email Address",
          validate: [
            {
              valueChecker: "eg6_prep_email",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: [
                  "eg1_prep_last",
                  "eg2_prep_first",
                  "eg4_prep_fein",
                  "eg5_prep_firm_name",
                  "eg6_prep_email",
                ],
                check: "ifValueExists",
              },
            },
            {
              email: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
          ],
          maxLength: 100,
          tooltip: `Enter the business email address of the person that prepared this application by or on behalf of the employer. Format must be in the format name@emailaddress.top-level domain. The email entered in this field must be the one regularly used by the preparer to send and receive electronic communications from the Department with respect to the processing of this application. If the preparer does not possess a business email address, please enter “N/A.”`,
        },
      ],
    },
  ],
};
